import React from "react";
import Logo from '../assets/images/logo.png'
import {useTranslation} from "react-i18next";
const Footer = ({changeLanguage}) => {
    const [ t, i18n ] = useTranslation(['home']);
    return (
        <footer className="footer pt-5">
            <div className="footer__content-wrapper">
                <img className="footer__logo" src={Logo}></img>
                <ul className="footer__menu">
                    <li className="footer__menu-item">
                        <a href="https://www.racksmafia.com/policies/terms-of-service" target="_blank">{t('CookiesPolicy')}</a>
                    </li>
                </ul>

                <ul className="footer__menu">
                    <li className="footer__social-menu-item">
                        <a href="https://www.twitch.tv/carlos_adams"><i className="fab fa-twitch fa-2x"></i></a>
                    </li>
                    <li className="footer__social-menu-item">
                        <a href="https://www.facebook.com/RACKS-MAFIA-103356221102327/"><i className="fab fa-facebook fa-2x"></i></a>
                    </li>
                    <li className="footer__social-menu-item">
                        <a href="https://www.instagram.com/racksmafia"><i className="fab fa-instagram fa-2x"></i></a>
                    </li>
                    <li className="footer__social-menu-item">
                        <a href="https://twitter.com/racksmafia"><i className="fab fa-twitter fa-2x"></i></a>
                    </li>
                </ul>
                <span className="copyright">Copyright 2022, <a target="_blank" href="https://www.racksmafia.com/">Racks Mafia</a></span>
                <div className="footer__menu_languague">
                    <i className="fa-solid fa-language fa-2x mt-2"></i>
                    <select className="form-select mt-2" onChange={(e)=> changeLanguage(e.target.value)}>
                        <option value={'es'}  selected={i18n.language == 'es'}>Es </option>
                        <option value={'en'}  selected={i18n.language == 'en'}>En</option>
                    </select>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
